import { useEffect, useCallback } from 'react';
import { routeConstants } from '../../../constants/routeConstants';
import { DEFAULTS } from '../constants';
import {
  clearOpenPostingRestoreIntent,
  clearOpenPostingState,
  setOpenPostingRestoreIntent,
  writeOpenPostingState,
} from '../utils/openPostingStateStorage';

export const useOpenPostingPersistenceEffects = ({
  shouldPersistOpenPostingState,
  shouldRestoreFromPersistedState,
  warnings,
  feedSourceData,
  isApplyingFilters,
}) => {
  useEffect(() => {
    if (!shouldPersistOpenPostingState) return;

    const normalizedWarnings = Array.isArray(warnings) ? warnings.filter(Boolean) : DEFAULTS.EMPTY_ARRAY;
    writeOpenPostingState({
      warnings: normalizedWarnings,
      warningCount: normalizedWarnings.length,
      feedSourceData: Array.isArray(feedSourceData) ? feedSourceData : DEFAULTS.EMPTY_ARRAY,
      isApplyingFilters: Boolean(isApplyingFilters),
    });
  }, [shouldPersistOpenPostingState, warnings, feedSourceData, isApplyingFilters]);

  useEffect(() => {
    if (!shouldPersistOpenPostingState) return;

    if (shouldRestoreFromPersistedState) {
      const clearRestoreIntentTimeoutId = window.setTimeout(() => {
        clearOpenPostingRestoreIntent();
      }, 0);
      return () => window.clearTimeout(clearRestoreIntentTimeoutId);
    }

    clearOpenPostingRestoreIntent();
  }, [shouldPersistOpenPostingState, shouldRestoreFromPersistedState]);

  useEffect(() => {
    if (!shouldPersistOpenPostingState) return undefined;

    return () => {
      const currentPathname = typeof window !== 'undefined' ? String(window.location?.pathname ?? '') : '';
      const normalizedPath = currentPathname.replace(/\/+$/, '');
      const machinesSubRoutePrefix = `/${routeConstants.MACHINES_ROUTE}/`;
      const isNavigatingToMachineSubRoute = normalizedPath.startsWith(machinesSubRoutePrefix);

      if (isNavigatingToMachineSubRoute) {
        setOpenPostingRestoreIntent();
        return;
      }

      clearOpenPostingState();
      clearOpenPostingRestoreIntent();
    };
  }, [shouldPersistOpenPostingState]);

  const clearPersistedOpenPostingState = useCallback(() => {
    clearOpenPostingState();
  }, []);

  return {
    clearPersistedOpenPostingState,
  };
};
